import React from 'react';
import { Button, Modal, ModalBody, ModalHeader, ModalFooter, } from 'reactstrap';
import { toast } from 'react-toastify';

import firebase from '../../firebase';
import { fields } from '../../shared/models/tag';
import useCollectionSubscription from '../hooks/useCollectionSubscription';
import AddButton from '../AddButton';
import EditButton from '../EditButton';
import DeleteButton from '../DeleteButton';
import ModelFormModal from './ModelFormModal';

const db = firebase.firestore();
const tagsRef = db.collection('tags');

export default function TagsManagementModal ({ isOpen, onClickClose }) {
  const tags = useCollectionSubscription(tagsRef.orderBy('createdAt'));
  const onClickCopyUrl = async (tagId) => {
    const url = `${window.location.origin}/?tag=${tagId}&signup=1`;
    try {
      await navigator.clipboard.writeText(url);
      toast.success('登録URLをコピーしました');
    } catch(e) {
      console.error(e);
      window.prompt('登録URLをコピーしてください', url);
    }
  };

  return (
    <Modal isOpen={isOpen} size="lg">
      <ModalHeader>
        タグ管理
      </ModalHeader>
      <ModalBody>
        <div className="mb-3">
          <AddButton
            itemRef={_ => tagsRef.doc()}
            FormModal={ModelFormModal}
            formProps={{ title: 'タグ追加', fields }}
          />
        </div>
        <table className="table">
          <thead className="thead-light">
            <tr>
              <th>タグ名</th>
              <th style={{ width: 320 }}></th>
            </tr>
          </thead>
          <tbody>
            {
              tags.map(tag => {
                const { id, ref, name } = tag;
                return (
                  <tr key={id}>
                    <td>{name}</td>
                    <td className="text-right text-nowrap">
                      <Button
                        size="sm"
                        color="primary"
                        outline
                        onClick={_ => onClickCopyUrl(id)}
                      >
                        <span className="fas fa-link mr-1" />
                        ユーザー登録URL
                      </Button>
                      <EditButton
                        size="sm"
                        className="ml-1"
                        itemRef={ref}
                        FormModal={ModelFormModal}
                        formProps={{ title: 'タグ編集', fields }}
                      />
                      <DeleteButton
                        size="sm"
                        className="ml-1"
                        item={tag}
                        itemRef={ref}
                      />
                    </td>
                  </tr>
                );
              })
            }
          </tbody>
        </table>
      </ModalBody>
      <ModalFooter>
        <Button className="cancel" onClick={onClickClose}>閉じる</Button>
      </ModalFooter>
    </Modal>
  );
};
